// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyD7gMCouiuTrxvYlFYsaXd7Km23jwgO6W4",
    authDomain: "panthersprotectingpanthers.firebaseapp.com",
    databaseURL: "https://panthersprotectingpanthers.firebaseio.com",
    projectId: "panthersprotectingpanthers",
    storageBucket: "panthersprotectingpanthers.appspot.com",
    messagingSenderId: "173247680109",
    appId: "1:173247680109:web:cbebabe9e323e4d15d3964",
    measurementId: "G-LGVM9829GM"
  },
  iscript_endpoint: 'https://imagenowmobile.fiu.edu:8080/img/script_dev',
  iscript_student: 'https://imagenowmobile.fiu.edu:8080/img/checkStudent',
  iscript_visitor: 'https://imagenowmobile.fiu.edu:8080/img/checkVisitor',
  iscript_tour: 'https://imagenowmobile.fiu.edu:8080/img/checkTour',
  iscript_visitor_submit: 'https://imagenowmobile.fiu.edu:8080/img/p3_visitors',
  iscript_visitor_response: 'https://imagenowmobile.fiu.edu:8080/img/saveResponseVisitor',
  iscript_visitor_tours_response: 'https://imagenowmobile.fiu.edu:8080/img/saveResponseVisitorTours',
  html_surveillance_endpoint: 'https://us-central1-panthersprotectingpanthers.cloudfunctions.net/surveillanceText',
  html_surveillance_info_endpoint: 'https://us-central1-panthersprotectingpanthers.cloudfunctions.net/surveillanceTextInfo'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
